// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetBookingActionStatusResponse

import { BookingStatus } from './enums.gen';

export type WidgetBookingActionStatusApiResponse = {
	status: BookingStatus;
};

export type WidgetBookingActionStatus = {
	status: BookingStatus;
};

export function hydrateWidgetBookingActionStatus(data: WidgetBookingActionStatusApiResponse): WidgetBookingActionStatus {
	return { ...data };
}